import React from 'react';
import { ArrowLeft, FileText, ShieldCheck, Palette, FileCode2, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const Changelog = () => {
  const updates = [
    {
      version: '1.2.0',
      date: 'Juillet 2026',
      title: 'Sécurité & Personnalisation',
      features: [
        { icon: <ShieldCheck size={18} />, text: 'Mise en place de Firebase App Check (reCAPTCHA) pour bloquer les bots lors de la création de compte.' },
        { icon: <Palette size={18} />, text: 'Ajustement du thème Abyssal avec un nouveau bleu acier pastel (#87b9de) et une meilleure lisibilité.' },
        { icon: <Sparkles size={18} />, text: 'La bordure "Argent" s\'adapte désormais au thème : grise acier en thème clair et argent brillante en thème sombre.' }
      ]
    },
    {
      version: '1.1.0',
      date: 'Juin 2026',
      title: 'Boutique & Thèmes',
      features: [
        { icon: <Palette size={18} />, text: 'Ajout de la boutique de personnalisation avec de nouveaux thèmes (Coton, Abyssal, etc.).' },
        { icon: <FileCode2 size={18} />, text: 'Optimisation de l\'affichage sur mobile et ajustement de l\'espace de l\'en-tête.' }
      ]
    }
  ];

  return (
    <div className="page-container">
      <SEO 
        title="Nouveautés | Masse-terclass"
        description="Découvre les dernières mises à jour et fonctionnalités de l'application Masse-terclass."
      />
      
      <header className="page-header sticky-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
          <Link to="/" className="back-button">
            <ArrowLeft size={24} />
          </Link>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <div className="header-icon-container" style={{ backgroundColor: 'rgba(255,255,255,0.05)' }}>
              <FileText size={24} />
            </div>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', margin: 0 }}>Nouveautés</h1>
          </div>
        </div>
        <p style={{ color: 'var(--text-secondary)', margin: 0 }}>Suivez les dernières mises à jour de l'application</p>
      </header>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '2.5rem', marginTop: '2rem' }}>
        {updates.map((update, index) => (
          <div key={index} className="card" style={{ padding: '1.5rem', position: 'relative', overflow: 'hidden', borderTop: '6px solid var(--secondary-color)' }}>
            {index === 0 && (
              <div style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#eab308', color: '#000', fontSize: '0.75rem', fontWeight: 'bold', padding: '0.25rem 0.75rem', borderBottomLeftRadius: '0.5rem' }}>
                Dernière version
              </div>
            )}
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '1.5rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1rem' }}>
              <div>
                <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: 'var(--primary-color)', display: 'flex', alignItems: 'center', gap: '0.5rem', margin: 0 }}>
                  v{update.version}
                </h2>
                <h3 style={{ fontSize: '1.125rem', fontWeight: '600', marginTop: '0.25rem', marginBottom: 0 }}>{update.title}</h3>
              </div>
              <span style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>{update.date}</span>
            </div>

            <ul style={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: 0, margin: 0, listStyle: 'none' }}>
              {update.features.map((feature, fIndex) => (
                <li key={fIndex} style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                  <div style={{ flexShrink: 0, backgroundColor: 'rgba(128, 128, 128, 0.15)', padding: '0.4rem', borderRadius: '0.4rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {feature.icon}
                  </div>
                  <span style={{ color: 'var(--text-primary)', lineHeight: '1.4' }}>{feature.text}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div style={{ textAlign: 'center', fontSize: '0.875rem', color: 'var(--text-secondary)', marginTop: '2rem' }}>
          D'autres fonctionnalités incroyables arrivent bientôt ! 🚀
        </div>
      </div>
    </div>
  );
};

export default Changelog;
